// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"0":"draw","177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"0":"d3d8f81d","165":"5cbcacfb","177":"3b762c8a","328":"4f7c96f7","571":"15f69a78","821":"d9715896"}[chunkId] + ".css";
};